export default "__VITE_ASSET__b4c1a81b__"